import { UrlState } from "@multimediallc/cb-roomlist-prefetch"
import { addEventListenerPoly } from "../../common/addEventListenerPolyfill"
import { normalizeResource } from "../../common/api"
import { HTMLComponent } from "../../common/defui/htmlComponent"
import { getCurrentGender, getVerboseGenderPath } from "../../common/genders"
import { i18n } from "../../common/translation"
import { dom } from "../../common/tsxrender/dom"
import { MobileSiteNotice } from "../components/MobileSiteNotice"
import { SubNavHeaderTabs } from "../components/roomlist/subNavHeaderTabs"
import { pageContext } from "../interfaces/context"
import { initSearchInput } from "../ui/searchBar/roomlistSearchInput"
import { SearchInput } from "../ui/searchBar/searchInput"
import { SortableTagTable } from "./sortableTagTable"
import { hideTagTableToolTip, updateTagTableGender, updateTagTableSortField } from "./tagTableEvents"
import type { Gender } from "../../common/genders"

interface ITrendingRootState {genderList: Gender[]}

interface ITrendingRootProps extends ITrendingRootState {showLocation: boolean}

export class TrendingRoot extends HTMLComponent<HTMLDivElement, ITrendingRootProps, ITrendingRootState> {
    private subNavTabs: SubNavHeaderTabs
    private tagTable: SortableTagTable

    constructor(props: ITrendingRootProps) {
        super(props)
        this.bindTopSection()
        this.element.appendChild(<SortableTagTable showLocation={props.showLocation} classRef={(c: SortableTagTable) => {
            this.tagTable = c
        }} />)
        this.bindSearchInput()
        this.bindSubNavTagTableUpdate()
        addEventListenerPoly("popstate", window, () => this.handleHistoryNavigation())
        addEventListenerPoly("pageshow", window, () => {
            hideTagTableToolTip.fire({ forceHide: true })
        })
    }

    protected createElement(): HTMLDivElement {
        return document.querySelector("#trending_root") as HTMLDivElement
    }

    private bindTopSection(): void {
        const topSection = document.querySelector(".top-section") as HTMLDivElement
        if (pageContext.current.showMobileSiteBannerLink === true) {
            // If shown, the mobile site banner should sit *above* the nav elements for visibility
            const mobileSiteNotice = new MobileSiteNotice()
            this.element.parentElement!.prepend(mobileSiteNotice.element)
            mobileSiteNotice.show()
        }
        this.subNavTabs = new SubNavHeaderTabs({
            firstTabTitle: i18n.allTagsCAPS,
            enableGenderedLinkUpdates: true,
            onTabClick: (gender) => {
                updateTagTableGender.fire(gender)
                UrlState.current.syncStateWithCurrentUrl()
            },
        })
        topSection.appendChild(this.subNavTabs.element)
    }

    protected bindSearchInput(): void {
        initSearchInput("search_icon")

        SearchInput.onSubmit.listen(input => {
            if (input === "") {
                return
            }
            const encodedKeywords = encodeURIComponent(input.trim())
            const genderPath = getVerboseGenderPath(getCurrentGender())
            window.location.href = normalizeResource(`/${genderPath}?keywords=${encodedKeywords}`)
        })
    }

    private bindSubNavTagTableUpdate(): void {
        updateTagTableSortField.listen(() => {
            this.subNavTabs.renderTabs()
        })
    }

    private handleHistoryNavigation(): void {
        this.subNavTabs.renderTabs()
        this.tagTable.loadTableFromExistingParams(false)
        hideTagTableToolTip.fire({ forceHide: true })
    }
}
